<template>
    <div v-if="hasTermsAndPolicy">
        <div class="my-1">
            <v-icon color="primary" small>mdi-information-outline</v-icon>
            {{ $translate(actionText) }}
            <a href="" @click.prevent="showTerms = true">{{$translate('TERMS_AND_CONDITIONS')}}</a>
            {{ $translate('and our handling of personal data in') }}
            <a href="" @click.prevent="showPolicy = true">{{ $translate('PRIVACY_POLICY') }}</a>.
        </div>

        <v-dialog max-width="500" scrollable v-if="showTerms" v-model="showTerms">
            <v-card style="overflow-y: auto">
                <component-wrapper :config="termsConfig" />

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        text
                        color="primary"
                        @click="showTerms = false"
                    >
                        {{$translate('Close')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog max-width="500" scrollable v-if="showPolicy" v-model="showPolicy">
            <v-card style="overflow-y: auto">
                <component-wrapper :config="policyConfig" />

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        text
                        color="primary"
                        @click="showPolicy = false"
                    >
                        {{$translate('Close')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'TermsNotice',

    props: {
        actionText: {
            type: String,
            default: 'By identifying yourself, you agree to'
        }
    },

    data: () => ({
        showTerms: false,
        showPolicy: false
    }),

    computed: {
        hasTermsAndPolicy() {
            let routes = this.$root.siteconfig?.routes;
            if (!routes) return false;
            return routes.some(x => x.props?.path == '/terms') && routes.some(x => x.props?.path == '/policy');
        },
        termsConfig() {
            return this.$root.siteconfig.routes.find(x => x.props.path == '/terms').props.config;
        },
        policyConfig() {
            return this.$root.siteconfig.routes.find(x => x.props.path == '/policy').props.config;
        }
    }
}
</script>
